import { initEnv } from '@tencent/pmd-tools/lib/env';

const HOR_CLASS = 'hor-layout';
const SMOBA_CLASS = 'smoba';
const SMOBA_VERTICAL_CLASS = 'smoba-vertical';
const SMOBA_PC_CLASS = 'smoba-pc';

export function isHor() {
  const env = initEnv();
  const res =  env.isInGame;
  return res;
}
export function isPC() {
  const env = initEnv();
  const res =  env.isPc;
  return res;
}

export function insertHorClass() {
  // #ifdef H5
  if (!isHor()) {
    const classes = document.body.classList;
    if (classes.contains(SMOBA_VERTICAL_CLASS)) return;
    document.body.classList.add(SMOBA_VERTICAL_CLASS);
    if (isPC()) {
      const classes = document.body.classList;
      if (classes.contains(SMOBA_PC_CLASS)) return;
      document.body.classList.add(SMOBA_PC_CLASS);
    }
    return;
  }
  const classes = document.body.classList;
  if (classes.contains(HOR_CLASS)) return;
  document.body.classList.add(HOR_CLASS);
  if (classes.contains(SMOBA_CLASS)) return;
  document.body.classList.add(SMOBA_CLASS);
  // #endif
}
